import { render, staticRenderFns } from "./prescriptionInfo.vue?vue&type=template&id=2329c6f4&scoped=true"
import script from "./prescriptionInfo.vue?vue&type=script&lang=js"
export * from "./prescriptionInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2329c6f4",
  null
  
)

export default component.exports